import React from "react";

import FilterContext from "../../Context/FilterContext";

import CheckBoxes from "../Checkboxes";

import {toggleFilterMenu} from "../../utils/filters";
import orderCookingTimes from "../../utils/helpers";

const FilterMenu = ({
    activeFilters,
    setActiveFilters,
    setActiveFiltersCounter,
    setApplyFilters,
    disableApplyFilters,
    resetFilters,
    enableProteinFilter,
    mainIngredientValues,
    courseValues,
    difficultyValues,
    cookingTimeValues,
    dietValues,
    fuelTypeValues,
    featuredValues,
    styleValues,
    applyFilters,
}) => (
    <div className="b-recipes-advanced-filter__filter-menu js-filter-menu">
        <FilterContext.Provider value={{activeFilters, setActiveFilters, setActiveFiltersCounter, setApplyFilters}}>
            <div className="filter-menu__content-wrapper">
                <button className="filter-menu__close-btn" onClick={toggleFilterMenu}>
                    <img className="e-icon" src={'/wp-content/themes/electro/img/svg/x-dark.svg'} alt={'Close'} width={'10'} height={'10'}/>
                </button>

                <form className="c-search-form filter-menu__search-form " role="search" method="get" action="/">
                    <label htmlFor="filter-menu-search">Search</label>
                    <input id="filter-menu-search" type="search" name="s" placeholder="Search" required/>
                    <img className="e-icon" src={'/wp-content/themes/electro/img/svg/search.svg'} alt={'Search'}/>
                </form>

                <h4 className="filter-menu__title">Filters</h4>
                <ul className="filter-menu__filter-list">
                    {enableProteinFilter && (
                        <li className="filter-menu__filter-type">
                            <CheckBoxes
                                label="Ingredient"
                                id="main-ingredient-sel"
                                options={mainIngredientValues}/>
                        </li>
                    )}
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Meal Type"
                            id="course-sel"
                            options={courseValues} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Difficulty"
                            id="difficulity-sel"
                            options={difficultyValues} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Cooking Time"
                            id="cooking-time-sel"
                            options={orderCookingTimes(cookingTimeValues)} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Diet"
                            id="diet-sel"
                            options={dietValues} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Fuel Type"
                            id="fuel-type-sel"
                            options={fuelTypeValues} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Featured"
                            id="featured-sel"
                            options={featuredValues} />
                    </li>
                    <li className="filter-menu__filter-type">
                        <CheckBoxes
                            label="Collections"
                            id="style-sel"
                            options={styleValues} />
                    </li>
                </ul>
            </div>

            <div className="filter-menu__controls-wrapper">
                <div className="filter-menu__controls">
                    <button
                        className="e-button e-button--filled-on-white e-button--large legacyStyle"
                        type="button"
                        tabIndex="0"
                        aria-label="Filter"
                        aria-disabled="false"
                        onClick={applyFilters}
                        disabled={disableApplyFilters}>
                        <span className="e-button__copy">Apply Filters</span>
                    </button>

                    <button
                        className="e-button e-button--outlined-light e-button--large legacyStyle"
                        type="button"
                        tabIndex="0"
                        aria-label="Filter"
                        aria-disabled="false"
                        onClick={resetFilters}>
                        <span className="e-button__copy">Reset</span>
                    </button>
                </div>
            </div>
        </FilterContext.Provider>
    </div>

)
export default FilterMenu;
